import ModalForm from "../../../components/base/forms/modal-form";
import FeedbackFieldGroup from "./feedback-field-group";

export default class FeedbackForm {
	constructor() {
		this.hashData = {};

		this.init();
	}

	init() {
		this.parseHash();

		try	{
			this.feedbackForm = new ModalForm({
				formId: 'feedback',
				uri: '/2.0/feedback',
				data: {
					referrer: location.href
				},
				modalClass: '-feedback',
				$modalTriggers: Array.from(document.querySelectorAll('[data-modal-trigger="feedback"]')),
				fieldGroups: [
					{
						fields: ['course', 'coaches'],
						Controller: FeedbackFieldGroup
					}
				],
				initialValues: Object.keys(this.hashData).length ? this.hashData : null,
				hash: 'form'
			});
		} catch (err) {
			console.error('Feedback Form:', err);
		}
	}

	parseHash() {
		let hashStr = location.hash.slice(1);

		if (!(/^form\?.+/).test(hashStr)) {
			return;
		}

		const paramPairs = hashStr.match(/([a-zA-Z]+=[^=&]+)+/g);

		if (!paramPairs) {
			return;
		}

		let params = paramPairs.map(item => item.split('='));
		const { fname, lname, tel, email, city, course, photo } = Object.fromEntries(params);

		const dataObj = {
			fname: fname ? decodeURIComponent(fname) : null,
			lname: lname ? decodeURIComponent(lname) : null,
			tel, email, city, course, photo
		};

		Object.keys(dataObj).forEach((key) => {
			let newKey = key;

			if (key === 'fname') {
				newKey = 'name';
			} else if (key === 'lname') {
				newKey = 'lastName';
			}

			if (dataObj[key]) {
				this.hashData[newKey] = dataObj[key];
			}
		});
	}
}